import Switch from 'react-router-dom/Switch';
import Route from 'react-router-dom/Route';
import autobind from 'core-decorators/lib/autobind';
import React from 'react';

import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ExplorePage from './pages/ExplorePage';
import PricingPage from './pages/PricingPage';




@autobind
class Routes extends React.Component {

	render(){
		return (
		<main>
			<Switch >
				<Route exact path="/" component={HomePage} />
				<Route exact path="/explore" component={ExplorePage} />
				<Route exact path="/pricing" component={PricingPage} />
				<Route exact path="/privacy-policy" component={PrivacyPage} />
				<Route exact path="/terms-and-conditions" component={TermsPage} />
				<Route exact path="/terms-of-service" component={TermsPage} />
				<Route component={HomePage} />
			</Switch>
		</main>
		);
	}

 }

 export default Routes;

 